export default __webpack_public_path__ + "static/media/chain-12.c6087168.png";